<div class="table-page dashboard-page">
  <header class="header">
    <div class="title-row">
      <button type="button" class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <h1 class="title">داشبورد عمومی</h1>
      <div class="actions">
        <button type="button" class="btn btn-ghost" id="filterToggle" [attr.aria-expanded]="filtersOpen"
          aria-controls="filtersWrap" (click)="filtersOpen = !filtersOpen">
          <i class="fa fa-sliders" aria-hidden="true"></i> فیلتر
          <i class="fa fa-chevron-down chev" aria-hidden="true"></i>
        </button>
        <span class="actions-sep" aria-hidden="true"></span>
        <button type="button" class="btn-round" title="راهنما" aria-label="راهنما" (click)="showHelp()">
          <i class="fa fa-question" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="collapsible" id="filtersWrap" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <div class="filters">
          <div class="field" [formGroup]="startDateForm">
            <label class="field-label" for="startDate">از تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'">
              <input id="startDate" type="text" formControlName="date" class="control num" readonly />
            </ng-persian-datepicker>
          </div>
          <div class="field" [formGroup]="endDateForm">
            <label class="field-label" for="endDate">تا تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'">
              <input id="endDate" type="text" formControlName="date" class="control num" readonly />
            </ng-persian-datepicker>
          </div>
          <label class="field" for="serviceArea">
            <span class="field-label">حوزه خدمت</span>
            <select class="control" id="serviceArea" [formControl]="serviceAreaControl">
              <option [ngValue]="-1">انتخاب کنید</option>
              <option *ngFor="let item of serviceAreas" [ngValue]="item.iMobileDomain">{{item.strComment}}</option>
            </select>
          </label>
          <div class="field">
            <label class="field-label" for="Stime">از ساعت</label>
            <div class="clockpicker">
              <input type="text" class="control num" id="Stime" readonly [formControl]="startTimeControl" />
            </div>
          </div>
          <div class="field">
            <label class="field-label" for="Etime">تا ساعت</label>
            <div class="clockpicker">
              <input type="text" class="control num" id="Etime" readonly [formControl]="endTimeControl" />
            </div>
          </div>
          <label class="field" for="vehicleType" *ngIf="!isRentalDashboard">
            <span class="field-label">نوع خودرو</span>
            <select id="vehicleType" [formControl]="vehicleTypeControl" class="control">
              <option value="-1">نمایش همه</option>
              <option *ngFor="let item of vehicleTypes" [ngValue]="item.tiMobileType">{{item.strComment}}</option>
            </select>
          </label>
          <div class="filter-actions">
            <button type="button" class="btn btn-primary" (click)="applyFilters()">
              <i class="fa fa-search" aria-hidden="true"></i> به روز رسانی
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="dashboard-grid">

    <div class="card dashboard-chart">
      <div>
        <app-chart [context]="vehicleStatusChart" (itemClick)="onVehicleStatusClick($event)"></app-chart>
      </div>
    </div>

    <div class="card dashboard-chart">
      <div>
        <app-chart [context]="vehicleActivityChart"></app-chart>
        <p class="dashboard-chart-summary"> <span>تعداد خودرو فعال {{activeVehicleCount}}</span> <span>تعداد خودرو:{{totalVehicleCount}}</span></p>
      </div>
    </div>

    <div class="card dashboard-chart">
      <div>
        <app-chart [context]="vehicleViolationChart"></app-chart>
      </div>
    </div>

    <div *ngIf="!isRentalDashboard" class="card dashboard-chart">
      <div>
        <app-chart [context]="vehicleGroupChart" (itemClick)="onVehicleGroupClick($event)"></app-chart>
      </div>
    </div>

    <div class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="vehicleAreaServiceChart" (itemClick)="onServiceAreaClick($event)"></app-chart>
      </div>
    </div>

    <div *ngIf="!isRentalDashboard" class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="vehicleTypeChart" (itemClick)="onVehicleTypeClick($event)"></app-chart>
      </div>
    </div>

    <div *ngIf="!isRentalDashboard" class="card dashboard-chart dashboard-chart--wide">
      <div class="dirI">
        <app-chart [context]="vehicleManufactureYearChart" (itemClick)="onManufactureYearClick($event)"></app-chart>
      </div>
    </div>

    <div class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="vehicleTrafficChart"></app-chart>
      </div>
    </div>

    <div *ngIf="!isRentalDashboard" class="card dashboard-chart dashboard-chart--wide">
      <div class="dirI">
        <app-chart [context]="highRiskDriversChart"></app-chart>
      </div>
    </div>

    <div *ngIf="!isRentalDashboard" class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="mostViolatingVehiclesChart"></app-chart>
      </div>
    </div>

    <div *ngIf="isRentalDashboard" class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-map-heading">
        <h3 class="dashboard-card-title">وضعیت پراکندگی تخلفات </h3>
      </div>
      <div class="dashboard-map-filter">
        <div class="field">
          <select class="control" (change)="onViolationTypeChange($event)">
            <option *ngFor="let item of violationTypes" value="{{item.tiJournalType}}">{{item.strComment}}
            </option>
          </select>
        </div>
      </div>
      <div class="dashboard-map">

        <div id="violationLocationsMap" class="fixed-mapCluster"></div>
      </div>
    </div>

    <div *ngIf="isRentalDashboard" class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-map-heading">
        <h3 class="dashboard-card-title">وضعیت پراکندگی دستگاه ها</h3>
      </div>
      <div class="dashboard-map">

        <div id="vehicleLocationsMap" class="fixed-mapCluster"></div>
      </div>
    </div>

  </div>

</div>

<app-dashboard-chart-vehicles-modal></app-dashboard-chart-vehicles-modal>
<app-dashboard-cluster-details-modal></app-dashboard-cluster-details-modal>
